import { ObjectIdAsHexString } from "kreate-common/modules/business-types";
import { z } from "zod";

export const GetArtworkInlinableFiles$Params = z.object({
  artworkId: ObjectIdAsHexString,
});

export type GetArtworkInlinableFiles$Params = z.infer<
  typeof GetArtworkInlinableFiles$Params
>;

// NOTE: later, if we support inline binary files, we can add
// fileIdToHex or fileIdToBase64.
// We can even unify the logic by adding fileIdToUrl.
export const GetArtworkInlinableFiles$Result = z.object({
  fileIdToText: z.record(z.string(), z.string()),
});

export type GetArtworkInlinableFiles$Result = z.infer<
  typeof GetArtworkInlinableFiles$Result
>;
